import React from 'react';
import {Link} from 'react-router-dom';
import { logo } from '../../assets/img';
import { FaFacebookF } from "react-icons/fa";
function Footer() {
  return (
    <div>
      <footer className="footer__1">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 space-y-20">
              <div className="footer__logo">
                <Link to="/">
                  <img src={logo} alt="logo" style={{height:"3rem"}} id="logo_js_f" />
                </Link>
              </div>
              <p className="footer__text">
              DtoC is a smart contract for a shared-liquidity NFT marketplace.
              </p>
              {/* <div>
                <ul className="footer__social space-x-10 mb-40">
                  <li>
                    <a href="https://www.facebook.com/" rel="noreferrer"  target="_blank" style={{background:"#e2eef1", borderRadius:"50%", fontSize:"2rem", height:"2.5rem", width:"2.5rem"}}>
                      <FaFacebookF size={23}  />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.messenger.com/" rel="noreferrer"  target="_blank">
                      <i className="ri-messenger-line" />
                    </a>
                  </li>
                  <li>
                    <a href="https://whatsapp.com" target="_blank" rel="noreferrer" >
                      <i className="ri-whatsapp-line"  />
                    </a>
                  </li>
                  <li>
                    <a href="https://youtube.com" target="_blank" rel="noreferrer" >
                      <i className="ri-youtube-line" />
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
            <div className="col-lg-2 col-6">
              <h6 className="footer__title">Dtoc</h6>
              <ul className="footer__list">
                <li>
                  <Link to="/marketplace"> Marketplace</Link>
                </li>
                <li>
                  <Link to="/live-auctions"> Live Auction </Link>
                </li>
                <li>
                  <Link to="/auction"> Auction</Link>
                </li>
                {/* <li>
                  <Link to="home-3"> Home3 </Link>
                </li> */}
              </ul>
            </div>
            <div className="col-lg-2 col-6">
              <h6 className="footer__title">Assets</h6>
              <ul className="footer__list">
                <li>
                  <Link to="profile"> Profile </Link>
                </li>
                <li>
                  <Link to="creators"> Creators </Link>
                </li>
                <li>
                  <Link to="collections"> Collections </Link>
                </li>
                <li>
                  <Link to="Activity"> Activity</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-6">
              <h6 className="footer__title">Company</h6>
              <ul className="footer__list">
                <li>
                  <Link to="upload-type"> Upload Types </Link>
                </li>
                <li>
                  <Link to="upload"> Upload </Link>
                </li>
                <li>
                  <Link to="connect-wallet"> Connect Wallet</Link>
                </li>
                <li>
                  <Link to="item-details"> Item details </Link>
                </li>
              </ul>
            </div>
          </div>
          <p className="copyright text-center">
            Copyright © 2024. Created with love by Dtoc.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
